
import Medal from "../../../assets/duotone/Medal.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MedalIcon({ className, dataTestid = "MedalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Medal data-testid={dataTestid} className={classes} {...rest} />
  );
}
